/* Combobox remoto de compañias, filtra por usuario */
import { useLazyQuery } from "@apollo/client";
import { SelectProps } from "antd";
import { COMPANIES } from "./ComboboxGQL";
import RemoteComboBox from "../../../shared/RemoteComboBox";

interface CompaniesComboBoxProps extends SelectProps<string> {
    pageSize?: number;
    parentid?: string;
    user_id?: string;
    onSelectFull?: (item: { id: string; name: string; product: string[] }) => void;
}

const CompaniesComboBox: React.FC<CompaniesComboBoxProps> = ({
    pageSize = 7,
    parentid,
    user_id,
    onSelectFull,
    ...props
}) => {
    const DEFAULT_VARIABLES = parentid ? {
        parentid,
    } : {
    };

    const [getData, { data, loading, error }] = useLazyQuery(
        COMPANIES,
        {
            fetchPolicy: "no-cache",
            variables: {
                ...DEFAULT_VARIABLES,
                search: "",
                combo: true,
                table: false,
                user_id,
            },
        }
    );

    const handleChange = (value: any, option: any) => {
        if (onSelectFull && data?.companiesByUser) {
            const id = typeof value === 'object' ? value?.value : value
            const found = data.companiesByUser.find((c: any) => c.id === id)
            if (found) onSelectFull(found)
            if (!value) onSelectFull({ id: '', name: '', product: [] })
        }
        props.onChange?.(value, option)
    }

    return (
        <RemoteComboBox
            {...props}
            onChange={handleChange}
            showSearch
            optionIdKey={"id"}
            optionValueKey={"name"}
            pageSize={pageSize}
            defaultVariables={DEFAULT_VARIABLES}
            fetchData={getData}
            data={data}
            optionFilterProp="children"
            dataKey={"companiesByUser"}
            loading={loading}
            error={error}
            addDropRender
        />
    );
};

export default CompaniesComboBox;
